import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { createElement } from '@wordpress/element';
import Edit from './edit';
import Save from './save';
import './style.scss';
import './editor.scss';

import logoImage from '../../assets/linear_logo_orange.png';

let renderBlock = false;
if( window.linear_admin_obj && linear_admin_obj.blocks && typeof linear_admin_obj.blocks.dynamicListings !== 'undefined' ) {
    renderBlock = linear_admin_obj.blocks.dynamicListings;
}

if( renderBlock ) {
    registerBlockType('linear/dynamic-listings-content', {
        title: __('Linear dynamic listings content', 'linear'),
        description: __('Display dynamically Linear listings and single listings', 'linear'),
        category: 'widgets',
        icon: {
            src: createElement('img', {
                src: logoImage,
                style: { width: '20px', height: '20px' }
            })
        },
        supports: {
            html: false,
        },
        attributes: {
            attributesList: {
                type: "array",
                default: []
            },
            className: {
                type: 'string',
                default: ''
            }
        },
        edit: Edit,
        save: Save,
    });
}